export default __webpack_public_path__ + "static/media/mexc.4ea562bf.png";